import * as actionType from '../constants/constant.action'

const defaultState = {
  loader: undefined,
}

const signInUserReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.SIGN_IN_USER_REQUEST_ASYNC:
      return {
        loader: true,
        error: '',
      }

    case actionType.CLEAN_SIGN_IN_USER_DETAIL:
      return {
        state,
      }

    case actionType.SIGN_IN_USER_REQUEST_SUCCESS:
      if (action.payload) {
        const signSession = JSON.stringify(action.payload)
        sessionStorage.setItem('signSession', signSession)
      }

      if (action.payload.response && action.payload.response.status === 500) {
        return {
          ...state,
          ...action.payload,
          loader: false,
          serverError: true,
          error: '',
        }
      }

      return {
        ...state,
        ...action.payload,
        loader: false,
      }

    case actionType.SIGN_IN_USER_REQUEST_FAILURE:
      return {
        ...state,
        error: action.payload.message,
        loader: false,
      }

    case actionType.SIGN_OUT_USER_REQUEST:
      return {
        ...defaultState,
      }

    case actionType.GET_USER_FAILURE:
      return {
        ...state,
        loader: false,
        error: action?.payload?.message || 'Get user error',
      }

    default:
      return {
        ...state,
      }
  }
}

export default signInUserReducer
